import utils from 'helpers/utils';
import {
    FETCH_MEMBERSHIP_POOLS,
    FETCH_MEMBERSHIP_POOLS_FAILURE,
    FETCH_MEMBERSHIP_POOLS_SUCCESS,
    FETCH_MEMBERSHIP_POOL,
    FETCH_MEMBERSHIP_POOL_FAILURE,
    FETCH_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const fetchMembershipPools = (payload) => {
    payload = payload || {};

    let params = {
        is_default: 0, // Don't show default values
        size: payload.size ? payload.size : 12,
        offset: payload.offset ? payload.offset : 0,
        page: payload.page ? payload.page : 1,
        sort_by: payload.field ? payload.field : 'name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (payload.name) {
        params.name = payload.name;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_MEMBERSHIP_POOLS,
        payload: params,
    };
};

export const fetchMembershipPoolsFailure = (error) => {
    return {
        type: FETCH_MEMBERSHIP_POOLS_FAILURE,
        error: error,
    };
};

export const fetchMembershipPoolsSuccess = (response) => {
    return {
        type: FETCH_MEMBERSHIP_POOLS_SUCCESS,
        response: response,
    };
};

export const fetchMembershipPool = (payload) => {
    return {
        type: FETCH_MEMBERSHIP_POOL,
        payload: payload,
    };
};

export const fetchMembershipPoolFailure = (error) => {
    return {
        type: FETCH_MEMBERSHIP_POOL_FAILURE,
        error: error,
    };
};

export const fetchMembershipPoolSuccess = (response) => {
    return {
        type: FETCH_MEMBERSHIP_POOL_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-pools/fetchMembershipPools.js